import classnames from 'classnames/bind';
import { ChatAgentSideBar } from 'components/ChatAgentSideBar/ChatAgentSideBar';
import { isIframeMode } from 'modules/taboola-common-frontend-modules/iframe/utils/isIframeMode';
import { useShowHeader } from './components/AppHeader/hooks/useShowHeader';
import { useChatAgentPermitted } from './components/ChatAgent/hooks/useChatAgentPermitted';
import { useNonAuthAccess } from './hooks/useNonAuthAccess';
import styles from './app.module.scss';

const classNameBuilder = classnames.bind(styles);

export const AppShape = ({ appHeader = null, sideBar = null, children, config }) => {
    const isChatAgentPermitted = useChatAgentPermitted();
    const iFrameMode = isIframeMode();
    const isMainApp = !iFrameMode;
    const showHeaderForModule = useShowHeader(config);
    const nonAuthAccess = useNonAuthAccess();
    const isSideContentHidden = !showHeaderForModule || nonAuthAccess;

    return (
        <div className={classNameBuilder('app-container', { 'main-app': isMainApp })}>
            {isMainApp && <div className={styles['side-content']}>{sideBar}</div>}
            <div
                className={classNameBuilder('main-content', {
                    'main-app': isMainApp,
                    'side-content-hidden': isSideContentHidden,
                })}
            >
                <div className={styles['top-content']}>{appHeader} </div>
                <div className={styles['app-content']}>{children} </div>
            </div>
            {isChatAgentPermitted && (
                <div className={classNameBuilder('side-content', 'chat-agent')}>
                    <ChatAgentSideBar />
                </div>
            )}
        </div>
    );
};
